// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z4QV","newExpiryDate":"styles_newExpiryDate__WeoRv","footer":"styles_footer__3a6_M"};